import {
  apiGet,
  apiPost,
  type ApiResponse,
} from "./genesisApi/httpsMethods";
import type {
  NotificationSettings,
  NotificationSettingsPayload,
} from "../types/notificationSettings";

const NOTIFICATION_SETTINGS_ENDPOINT = "notification_settings";

export async function getNotificationSettings(): Promise<
  ApiResponse<NotificationSettings>
> {
  return apiGet<NotificationSettings>(NOTIFICATION_SETTINGS_ENDPOINT);
}

export async function saveNotificationSettings(
  body: NotificationSettingsPayload,
): Promise<ApiResponse<NotificationSettings>> {
  return apiPost<NotificationSettings>(NOTIFICATION_SETTINGS_ENDPOINT, body);
}
